import { jsonFetch } from "@/lib/helpers";
import { HostawayListing } from "@/models/integrations";
import { getHostawayListingsUrl } from "./api-url.constants";

export const getHostawayListings = async (userId?: string): Promise<HostawayListing[]> => {
  const response = await jsonFetch<{ data: HostawayListing[] }>(getHostawayListingsUrl(userId));
  return response.data;
};
